import { Container, Row, Col } from 'react-bootstrap';
import StatCard from './components/StatCard';
import { useExternalMedia } from "../../hooks/useExternalMedia";




export default function Statistics() {
  const {unemployment1, unemployment2, unemployment3} = useExternalMedia()
  return (
    <>
      <section
        id="statistics"
        className="section statistics-content-section"
      >

        <Container>
          <Row>

            <Col
              xs={{ span: 12, order: 1 }}
              md={{ span: 6, order: 1 }}
              lg={{ span: 4, order: 1 }}
            >
              <StatCard
                statImg={unemployment1}
                statText="In 2022, approximately 12.7 percent of African youth were unemployed."
              />
            </Col>

            <Col
              xs={{ span: 12, order: 1 }}
              md={{ span: 6, order: 1 }}
              lg={{ span: 4, order: 1 }}
            >
              <StatCard
                statImg={unemployment2}
                statText="By 2025, 263 million young Africans will lack an economic stake in the system."
              />
            </Col>

            <Col
              xs={{ span: 12, order: 1 }}
              md={{ span: 6, order: 1 }}
              lg={{ span: 4, order: 1 }}
            >
              <StatCard
                statImg={unemployment3}
                statText="Africa's youth population will rapidly double to more than 830 million by 2050."
              />
            </Col>

          </Row>
        </Container>
      </section>

    </>
  )
}